class TiktokEmbed extends HTMLElement {
  constructor() {
    super();

    this.openModalTrigger = this.querySelector('[data-modal-open]');
    this.modal = document.querySelector(`tiktok-modal[data-id="${this.dataset.modal}"]`);

    this.init();
    this.listeners();
  }

  init() {

    // const script = document.createElement("script");

    // script.async = true;
    // script.src = "https://www.tiktok.com/embed.js";
    // script.onload = () => {
    //   this.openModalTrigger.setAttribute("aria-busy", false);
    // };

    // this.modal.appendChild(script);
  }

  listeners() {

    this.openModalTrigger.addEventListener('click', () => {
      this.modal.openModal();
    });
  }
}

customElements.define('tiktok-embed', TiktokEmbed);